<template>
  <div>
    <div class="com-banner" style="background-image:url(http://fs.58keeper.com/about-bg.jpg)">
      <div class="banner-inner center">
        <h1>关于多妙</h1>
        <p>最懂旅游地产的民宿托管运营商</p>
      </div>
    </div>
    <div class="section about-content">
      <div class="com-container">
        <div class="c-title vertical">think deeper</div>
        <h2>公司简介</h2>
        <div class="content">
          <p>
            多妙专注于服务旅游城市的房东和旅行者。<br>
            是广受旅行者喜爱的民宿品牌，链接旅游地产的闲置房源与游客。<br>
            一方面希望成为房东的得力管家，帮助打理照看房屋的同时让房间分享利用。<br>
            一方面希望成为旅行者美妙旅程的组成部分，提供不同于酒店的居住体验。<br>
            凝合当地的文化与风情，让每个旅行者都能感受到美宿带来的舒适与风景。
          </p>
          <br>
          <br>
          <div class="img">
            <img src="http://fs.58keeper.com/about1.jpg" alt="多妙">
          </div>
        </div>
      </div>
    </div>
    <div class="section val-content">
      <div class="auto-container">
        <div class="val-left"></div>
        <div class="val-right">
          <div class="content-box">
            <h2>责任与使命</h2>
            <p>
              专注闲置房产托管经营<br>
              让闲散资源创造价值<br>
              成为最懂旅游地产的民宿运营商
            </p>
          </div>
          <div class="bs-inline">
            <img src="http://fs.58keeper.com/about2.jpg" alt="多妙">
          </div>
        </div>
      </div>
    </div>
    <div class="section about-txt">
      <div class="com-container">
        <p>
          离岛房东的好管家，让闲散资源创造价值，免费养护与创造收益<br>
          游客的度假助手，美妙旅程的组成部分，一站式提升出游体验<br>
          物业的好伙伴，协同管理，共同服务业主，提升业主满意度
        </p>
        <div class="circle-img">
          <img src="http://fs.58keeper.com/about3.png" alt="多妙">
        </div>
        <h2>多妙，让闲散资源创造价值</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data: function () {
    return {}
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/About.vue